// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-5.use[1]!../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-5.use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-5.use[3]!../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-5.use[4]!./documents.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("0b6d3f30", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-5.use[1]!../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-5.use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-5.use[3]!../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-5.use[4]!./documents.scss", function() {
     var newContent = require("!!../../../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-5.use[1]!../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-5.use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-5.use[3]!../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-5.use[4]!./documents.scss");
     if(newContent.__esModule) newContent = newContent.default;
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}